/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import { Button, Input, SimpleSelect } from 'components/atoms';
import { DateInputPicker } from 'components/atoms/DateInputPicker';
import { Modal } from 'components/molecules/Modal';
import { useAddCategory, useGetCategoryList, useRemoveCategory } from 'framework/api/methods';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export interface CategoriesProps {
  [x: string]: any;
}

export const Categories: FC<CategoriesProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [categoryList, setCategoryList] = useState([]);
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categoryName, setCategoryName] = useState('');

  const onSuccessGetCategoryList = (data: any) => {
    setCategoryList(data?.creators ?? []);
  };

  const onErrorGetCategoryList = ({ response: { data: errData }, response }: any) => {
    setCategoryList([]);
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { refetch: getCategoryList, data } = useGetCategoryList(
    onSuccessGetCategoryList,
    onErrorGetCategoryList,
  );
  const { mutate: removeCategoryMutate, isLoading: removeCategoryIsOnLoading } =
    useRemoveCategory();

  const { mutate: addCategoryMutate, isLoading: addCategoryIsOnLoading } = useAddCategory();

  useEffect(() => {
    getCategoryList();
  }, []);

  // function to delete category
  const removeCategory = () => {
    removeCategoryMutate(
      {
        categoryId: selectedCategory,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          getCategoryList();
          setSelectedCategory('');
          setIsOpenDeleteConfirmation(false);
          notify(successData?.message || 'Category deleted', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to add category
  const addCategory = () => {
    addCategoryMutate(
      {
        categoryName,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          getCategoryList();
          setCategoryName('');
          notify(successData?.message || 'New category added.', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  return (
    <div className="flex justify-center items-start w-full h-full p-8 overflow-y-auto gap-x-5 gap-y-3 lg:flex-row flex-col">
      <div className="w-1/2 bg-white h-full rounded-[20px] p-5">
        <div className="font-semibold text-lg text-[#05004E]">Top Categories</div>

        <div className="pt-5 flex flex-col w-full">
          <div className="flex justify-between w-full text-[#96A5B8] pb-2 mb-1 border-b border-[#EDF2F6]">
            <div className="w-2/12 text-xs">#</div>
            <div className="w-10/12 text-xs text-start">Category Listing</div>
          </div>

          <div className="w-full flex flex-col lg:overflow-y-auto h-full">
            {categoryList?.map((cat: any, index) => (
              <div
                className="flex justify-between w-full text-[#444A6D] py-3 border-b gap-x-2 border-[#EDF2F6]"
                key={index}
              >
                <div className="w-2/12 text-xs">
                  {index < 9 && `0`}
                  {index + 1}
                </div>
                <div className="w-8/12 text-xs flex flex-col justify-between items-start">
                  <div className="text-sm font-medium text-[#63717A] max-w-[400px] h-full max-h-[70px] overflow-y-auto">
                    {cat?.category_name}
                  </div>
                </div>
                <div className="w-2/12 text-xs">
                  <i
                    className="ri-close-line text-[16px] bg-red-600 rounded text-white cursor-pointer hover:bg-red-500"
                    onClick={() => {
                      setSelectedCategory(cat.category_id);
                      setIsOpenDeleteConfirmation(true);
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-1/2 bg-[white] h-1/2 rounded-[20px] p-5">
        <div className="flex justify-center flex-col items-center h-full w-full">
          <div className="font-semibold text-lg text-[#05004E] text-center">Add a new category</div>
          <div className="w-1/2 mt-6">
            <Input
              inputClassName="!rounded"
              appearance="gray"
              placeholder="Enter category"
              value={categoryName}
              onChange={(e: any) => {
                setCategoryName(e.target.value);
              }}
            />
          </div>
          <Button
            isRounded
            className="mt-5"
            disabled={!categoryName}
            onClick={() => {
              addCategory();
            }}
          >
            Add
          </Button>
        </div>
      </div>

      <Modal
        isActive={isOpenDeleteConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: removeCategoryIsOnLoading,
        }}
        onClickPrimaryBtn={() => {
          removeCategory();
        }}
        onClickSecondaryBtn={() => {
          setSelectedCategory('');
          setIsOpenDeleteConfirmation(false);
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#C40D42]"
              onClick={() => {
                setIsOpenDeleteConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#C40D42]" />
            <div className="pt-1 text-base text-[#737791] pb-3">
              Are you sure you want to delete this category?
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Categories;
